import { useContext, useState } from 'react';
import animationContext from 'context/animation';
import PUBLIC_ROUTES from '_helpers/constants/ConstPublicRoutes';

const useAnimation = () => {
  const { animation, setAnimation, currentPageIndex, setCurrentPageIndex } = useContext(animationContext);

  const [nextPage, setNextPage] = useState(PUBLIC_ROUTES[currentPageIndex + 1]);
  const [previousPage, setPreviousPage] = useState(PUBLIC_ROUTES[currentPageIndex - 1]);

  const ANIMATIONS = {
    initial: { opacity: 0, y: animation === 'next' ? 100 : -100 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: animation === 'next' ? -100 : 100 },
  };

  return {
    ANIMATIONS,
    setAnimation,
    currentPageIndex,
    setCurrentPageIndex,
    nextPage,
    setNextPage,
    previousPage,
    setPreviousPage,
  };
};
export default useAnimation;
